import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TablePagination } from '../../../../../common/details-table/table-pagination.component';
import LineItemsLayoutComponent from '../../../../invoice/invoice/line-items/line-items-layout.component';
import { AUDIT_NOTE, DEFAULT_TABLE_RESULT_MODEL, MODAL_CUSTOM_MESSAGE, TABLE_PAGINATION_KEY } from '../../../../../../constants/external-constants';
import { httpPost } from '../../../../../../utils/api.utils';
import { RechargeInventoryDetailsActions } from '../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';
import { NoSubscription } from '../../../../dashboard/no-subscription/no-subscription.component';
class CircuitLineItems extends Component {
    constructor(props){
        super(props);
        this.state = {
            showModal: false,
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            selectedItem: "",
            auditNote: AUDIT_NOTE.auditNote,
            isLoading: false,
            columnClicked: '',
            isSortedAsc: false
        }
    }
    componentDidMount() {

        const { getRechargeLineItems,resizeRechargeLineItemsPage, rechargeInventoryDetailsForm} = this.props;
        resizeRechargeLineItemsPage(20);
        getRechargeLineItems(rechargeInventoryDetailsForm.circuitInformation?.circuitId)
    }
    componentWillUnmount() {
        this.props.resetInvoiceLineItems();
    }
    
    onGetLineItems = (pageIndex) => {
        const { getRechargeLineItems, rechargeInventoryDetailsForm} = this.props;
        getRechargeLineItems(rechargeInventoryDetailsForm.circuitInformation?.circuitId, pageIndex);
    }
    onColumnSearchCircuitLineItems = () => {
        const { getRechargeLineItems, rechargeInventoryDetailsForm} = this.props;
        getRechargeLineItems(rechargeInventoryDetailsForm.circuitInformation?.circuitId)
    }
    onColumnSortLineItems = (columnClicked, isSortedAsc) => {
        const { rechargeInventoryDetailsForm, sortRechargeLineItems } = this.props;
        sortRechargeLineItems(columnClicked, isSortedAsc, rechargeInventoryDetailsForm.circuitInformation?.circuitId);
        this.setState({columnClicked: columnClicked, isSortedAsc: isSortedAsc})
    }
    resizePage = (value) => {
        const { getRechargeLineItems,resizeRechargeLineItemsPage, rechargeInventoryDetailsForm} = this.props;
        
        resizeRechargeLineItemsPage(value)
        getRechargeLineItems(rechargeInventoryDetailsForm.circuitInformation?.circuitId)
    }

    displaySearchField = () =>{
        this.setState({displaySearch:!this.state.displaySearch})
    }

    onClickExtractLineItems = () => {
        const {rechargeInventoryDetailsForm, extractCircuitLineItems} = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractCircuitLineItems(this.state.columnClicked, this.state.isSortedAsc, rechargeInventoryDetailsForm.circuitInformation?.circuitId);
        }
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }
    render() {
        const { rechargeInventoryDetails, setRechargeLineItemsColSearchStr } = this.props;
        return (
        
            <>

            <LineItemsLayoutComponent 
                    viewSearchAction={this.displaySearchField}
                    extractAction={this.onClickExtractLineItems}
                    extractEBillData={this.onClickExtractEbill}
                    hasDetailsContainer={false}
                    hasEbill={false}
             >
             {rechargeInventoryDetails?.isRechargeLineItemLoaded?

                <TablePagination

                    key={TABLE_PAGINATION_KEY.rechargingInventory}  
                    classNameWrapper="overflow-auto" 
                    columns={rechargeInventoryDetails?.rechargeLineItems?.Headers}
                    pageList={rechargeInventoryDetails?.rechargeLineItems?.Data?.Items}
                    pages={rechargeInventoryDetails.rechargeLineItems.Pagination}
                    rowClickAction={(item, hasLink) => {  }}
                    paginationAction={this.onGetLineItems}
                    onColumnClick={this.onColumnSortLineItems}
                    onColumnSearch={() => { this.onColumnSearchCircuitLineItems() }}
                    onColumnSearchChange={setRechargeLineItemsColSearchStr}
                    isColSearchShow={this.state.displaySearch}
                    resizePage={this.resizePage}
                    totalPage={rechargeInventoryDetails?.rechargeLineItems?.Pagination?.PerPage ?? {}}
                    paginationHidden={false}
                />
            : this.loading()}
              </LineItemsLayoutComponent>
            </>
        );
    }
}

export default connect(
    state => {
        const { rechargeInventoryDetails } = state;
        const { rechargeInventoryDetailsForm, forms: { rechargeInventoryDetailsForm: { $form } } } = state.form;
        
        return {
             rechargeInventoryDetails, rechargeInventoryDetailsForm, $form
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, RechargeInventoryDetailsActions),
        dispatch
    )
)(CircuitLineItems);
